<template lang="html">
  <div class="groner">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>Groner <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div v-if="activeIntegration">
              <font
                title="Configurações"
                size="6"
                color="black"
                @click.prevent="toogleUpdateIntegration()">
                <i class="ik ik-settings" />
              </font>
            </div>
            <div v-else>
              <font
                title="Configurações"
                size="6"
                color="gray">
                <i class="ik ik-settings" />
              </font>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="groner"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com Groner?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-lg modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurar Groner</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              v-if="error"
              class="alert alert-danger"
              role="alert">
              <span v-html="error.message" />
            </div>
            <div class="form-group row">
              <label
                for="gronerSubdomain"
                class="col-sm-4 col-form-label">Subdomínio</label>
              <div class="col-sm-8">
                <div class="input-group">
                  <span class="input-group-prepend">
                    <span class="input-group-text">https://</span>
                  </span>
                  <input
                    id="gronerSubdomain"
                    ref="gronerSubdomain"
                    type="text"
                    class="form-control"
                    tabindex="1"
                    v-model="gronerSubdomain">
                  <span class="input-group-append">
                    <span class="input-group-text">.groner.app</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="gronerEmail"
                class="col-sm-4 col-form-label">Email Groner</label>
              <div class="col-sm-8">
                <input
                  id="gronerEmail"
                  type="text"
                  class="form-control"
                  tabindex="3"
                  v-model="gronerEmail">
              </div>
            </div>
            <div class="form-group row">
              <label
                for="gronerPassword"
                class="col-sm-4 col-form-label">Senha Groner</label>
              <div class="col-sm-8">
                <div class="input-group">
                  <input
                    id="gronerPassword"
                    type="password"
                    class="form-control"
                    autocomplete="new-groner-password"
                    v-model="gronerPassword"
                    required>
                  <span class="input-group-append">
                    <a
                      class="input-group-text"
                      href="#"
                      @click.prevent="togglePasswordVisibility()">
                      <i class="ik ik-eye" />
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="credentialsAccessToken"
                class="col-sm-4 col-form-label">
                Token de acesso
              </label>
              <div class="col-sm-8 credentialsLabel">
                <span>{{ credentialsAccessToken }}</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração com a Groner atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Groner removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="tutorialGroner"
      ref="tutorialGroner"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Tutorial Groner</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <iframe
              width="760"
              height="420"
              src="https://www.youtube.com/embed/5d4Q7Kj2Y1Y"
              title="Tutorial Groner"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import Groner from '@/services/groner-wrapper'

export default {
  name: 'IntegrationGroner',
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      gronerSubdomain: null,
      gronerEmail: this.$store.state.auth.user.email,
      gronerPassword: null,
      gronerCredentials: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return loopback
        .get(`/integrations?filter[where][gateway]=groner`)
        .then(integrations => {
          this.integration = integrations.pop()
          if (this.integration && this.integration.metadata) {
            this.gronerSubdomain = this.integration.metadata.subdomain
            this.gronerEmail = this.integration.metadata.email
            this.gronerCredentials = this.integration.metadata.credentials
          }
          this.configReady = true
        })
        .catch(err => { this.$emit('onError', err) })
    },
    saveIntegration () {
      if (this.gronerSubdomain && this.gronerEmail && this.gronerPassword && this.configReady) {
        this.error = null
        return Groner.getToken(
          this.gronerSubdomain,
          this.gronerEmail,
          this.gronerPassword
        ).then(credentials => {
          this.gronerCredentials = credentials
          const integrationParams = {
            gateway: 'groner',
            webhook: true,
            webhookConstraint: {
              metadata: {
                api4comGateway: 'groner'
              }
            },
            metadata: {
              subdomain: this.gronerSubdomain,
              email: this.gronerEmail,
              credentials: this.gronerCredentials,
              webhookUrl: `${process.env.API4COM_BASE_URL_API}${process.env.API4COM_VERSION_API}/integrations/webhook`,
              webhookVersion: 'v1.4',
              webhookTypes: ['channel-hangup']
            }
          }
          if (this.integration) integrationParams.id = this.integration.id
          loopback
            .patch('/integrations', integrationParams)
            .then(integration => {
              this.integration = integration
              $(this.$refs.updateIntegration).modal('hide')
              $(this.$refs.successIntegration).modal('show')
            })
            .catch(err => {
              this.error = err
              if (err && err.details) {
                this.error = {
                  message: Object.values(err.details.messages).join('<br />')
                }
              }
            })
        }).catch(err => {
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.ResponseException &&
            err.response.data.ResponseException.ExceptionMessage
          ) {
            this.error = {
              message: err.response.data.ResponseException.ExceptionMessage
            }
          } else {
            this.error = {
              message: 'Erro ao tentar gerar o token de acesso com a Groner'
            }
          }
        })
      } else {
        this.error = {
          message: 'Subdomínio, Email e Senha são obrigatórios'
        }
      }
    },
    toogleIntegration (event) {
      if (event.value === true) {
        setTimeout(_ => {
          this.$refs.gronerSubdomain.focus()
        }, 500)
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.gronerSubdomain = null
          this.gronerPassword = null
          this.gronerEmail = null
          this.credentials = null
          this.error = null
          this.configReady = false
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    openTutorial () {
      $(this.$refs.tutorialGroner).modal('show')
    },
    togglePasswordVisibility () {
      const input = $('#gronerPassword')
      if (input[0].type === 'password') {
        input[0].type = 'text'
      } else {
        input[0].type = 'password'
      }
    }
  },
  computed: {
    activeIntegration () {
      return this.integration && this.integration.gateway === 'groner'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    },
    credentialsAccessToken () {
      if (!this.gronerCredentials) return 'Não gerado'
      const now = new Date()
      const expiration = new Date(this.gronerCredentials.expiration)
      if (expiration && expiration > now) {
        return `${this.gronerCredentials.funcao} expira em ${expiration.toLocaleDateString()}`
      } else {
        return 'Expirado'
      }
    }
  },
  watch: {
    gronerEmail: function (value) {
      if (value) {
        this.gronerEmail = value.replace(/[^A-Za-z0-9|_.@+-]/, '').toLowerCase()
        // eslint-disable-next-line
        const regexToValidateEmail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        if (this.gronerEmail && regexToValidateEmail.test(this.gronerEmail)) {
          this.error = null
        } else {
          this.error = {
            message: 'Email inválido'
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.credentialsLabel {
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Integration/Groner.vue